import { AfterViewChecked, Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { DealerMessageModel, ProductModel } from './shop.model';
import { ShopService } from './shop.service';
import { CookieService } from 'ngx-cookie-service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastService } from '../core/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shop-detail',
  templateUrl: './shop-detail.component.html'
})


export class ShopDetailComponent implements OnInit, AfterViewChecked {
  private productID: string                = null;
  private favoriteCookie: string[]         = null;
  public modalRef: BsModalRef;
  public productData: ProductModel         = null;
  public productDataLoaded: boolean        = false;
  public dealerMessage: DealerMessageModel = new DealerMessageModel();
  public bCanInitializeSlideshow: boolean  = false;
  public bNotFound: boolean                = false;


  constructor(
    protected router: UIRouter,
    private shopService: ShopService,
    private cookies: CookieService,
    private modal: BsModalService,
    private toastService: ToastService,
    private translate: TranslateService,
    @Inject('WINDOW') private window: any
  ) {
    if (!router.stateService.params.productID) {
      router.stateService.go('shop');
    } else {
      this.productID = router.stateService.params.productID;
    }

    if (this.cookies.check('leolux_favorites')) {
      this.favoriteCookie = JSON.parse(this.cookies.get('leolux_favorites'));
    }
  }

  public ngOnInit(): void {
    this.getProductData();
  }

  public addToFavorites(): void {
    if (this.favoriteCookie !== null) {
      if (this.isInFavorites(this.productData.id) < 0) {
        this.favoriteCookie.push(this.productData.id);
        this.cookies.set('leolux_favorites', JSON.stringify(this.favoriteCookie), 7, '/');
      }
    } else {
      this.favoriteCookie = [];
      this.favoriteCookie.push(this.productData.id);
      this.cookies.set('leolux_favorites', JSON.stringify(this.favoriteCookie), 7, '/');
    }
    this.productData.favorite = true;
  }

  public removeFromFavorites(): void {
    if (this.favoriteCookie !== null) {
      this.favoriteCookie.splice(this.isInFavorites(this.productData.id), 1);
      if (this.favoriteCookie.length > 0) {
        this.cookies.set('leolux_favorites', JSON.stringify(this.favoriteCookie), 7, '/');
      } else {
        this.cookies.delete('leolux_favorites', '/');
      }
    }
    this.productData.favorite = false;
  }

  public openModal(template: TemplateRef<any>): void {
    this.dealerMessage.product_id = this.productData.id;
    this.dealerMessage.email_dealer = this.productData.dealer_email;
    this.dealerMessage.product = this.productData.model;
    this.modalRef = this.modal.show(template, { class: 'modal-lg', animated: false });
  }

  public closeModal(): void {
    this.modalRef.hide();
    this.dealerMessage = new DealerMessageModel();
  }

  public messageDealer(): void {
    this.shopService.postDealerMessage(this.dealerMessage).subscribe(() => {
      this.toastService.success(this.translate.instant('shop-detail.modal.submit-success'));
      this.modalRef.hide();
    }, () => {
      this.toastService.error(this.translate.instant('shop-detail.modal.submit-error'));
    });
  }

  public searchForDealer(): void {
    if (this.productData.dealer_ser_no) {
      this.router.stateService.go('shop', {dealer: this.productData.dealer_ser_no});
    }
  }

  public ngAfterViewChecked(): void {
    if (this.bCanInitializeSlideshow) {
      this.window.slider.init();
      this.bCanInitializeSlideshow = false;
    }
  }

  private getProductData(): void {
    this.shopService.getProductDetail(this.productID).subscribe((res) => {
      if (res && res.length === 1 && res[0]) {
        this.productData = res[0];
        if (this.isInFavorites(this.productData.id) >= 0) { this.productData.favorite = true; }
        this.bCanInitializeSlideshow = true;
      } else {
        this.bNotFound = true;
      }
    }, () => {
      this.bNotFound = true;
      this.toastService.error(this.translate.instant('generic.errors.generic-error'));
    }, () => {
      this.productDataLoaded = true;
    });
  }

  private isInFavorites(id: string): number {
    return (this.favoriteCookie !== null) ? this.favoriteCookie.indexOf(id) : -1;
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shop/shop-detail.component.ts